<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.processingOrderNo') + ':'" prop="processingOrderNo">
            <el-input
              v-model.trim="form.processingOrderNo"
              name="processingOrderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.purchaseOrderNo') + ':'" prop="purchaseOrderNo">
            <el-input
              v-model.trim="form.purchaseOrderNo"
              name="purchaseOrderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialNo') + ':'" prop="materialNo">
            <el-input
              v-model.trim="form.materialNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.specificationNo') + ':'" prop="specificationNo">
            <el-input
              v-model.trim="form.specificationNo"
              name="specificationNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.deliveryDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count') + ':'" prop="count">
            <el-input
              v-model.trim.number="form.count"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.boxNo') + ':'" prop="boxNo">
            <el-input
              v-model.trim="form.boxNo"
              name="boxNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64">
              <template slot="prepend">#</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="labelIFrameYuanHengDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import {
    validateCount,
  } from '@/utils/validate';
  import {
    initYuanHengLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';

  export default {
    name: "YuanHengLabelDialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        form: {
          processingOrderNo: undefined,
          purchaseOrderNo: undefined,
          materialNo: undefined,
          specificationNo: undefined,
          deliveryDate: undefined,
          count: undefined,
          boxNo: undefined,
        },
        rules: {
          processingOrderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.processingOrderNoCanNotBeEmpty')
          }],
          purchaseOrderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.purchaseOrderNoCanNotBeEmpty')
          }],
          materialNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNoCanNotBeEmpty')
          }],
          specificationNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.specificationNoCanNotBeEmpty')
          }],
          deliveryDate: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
          count: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          boxNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('validate.boxNoCanNotBeEmpty')
          }],
        }
      };
    },
    watch: {
      visible(newValue) {
        if (newValue) {
          setTimeout(() => {
            this.initYuanHengLabelFrame();
          });
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.printYuanHengLabelFrame();
          }
        });
      },
      initYuanHengLabelFrame() {
        let iframe = document.getElementById('labelIFrameYuanHengDialog');
        iframe = initYuanHengLabelFrame({
          iframe,
          processingOrderNo: 'YHD193289-193291',
          purchaseOrderNo: 'PDDRD084142/1',
          materialNo: '1.08.01.00153',
          specificationNo: 'LS9929STR/SSOP24',
          deliveryDate: '2020-09-15',
          count: 3500,
          boxNo: '#001'
        });
        iframe.contentWindow.document.close();
      },
      printYuanHengLabelFrame() {
        const {
          processingOrderNo,
          purchaseOrderNo,
          materialNo,
          specificationNo,
          deliveryDate,
          count,
          boxNo,
        } = this.form;
        let iframe = document.getElementById('labelIFrameYuanHengDialog');
        iframe = initYuanHengLabelFrame({
          iframe,
          processingOrderNo,
          purchaseOrderNo,
          materialNo,
          specificationNo,
          deliveryDate,
          count,
          boxNo
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
